// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2kTMD","errors":"Errors_errors__1D9eL"};